import { ClinicScheduleStatusDto, DoctorDto } from "../web-api-client";
import { normalizeVi } from "./normalize";

export function searchDoctors(
  query: string,
  doctors: DoctorDto[]
): DoctorDto[] {
  const qRaw = (query ?? "").trim();
  if (!qRaw) return doctors;

  const qNorm = normalizeVi(qRaw);
  // Phát hiện alias “bác sĩ”
  const doctorWord =
    /\bbac\s*si\b|\bb\s*s\b|\bbs\b|\bbsi\b|\bdr\b|\bdoctor\b|\bmd\b/.test(
      qNorm
    );

  // Loại bỏ các alias “bác sĩ” để lấy phần còn lại
  const qRest = qNorm
    .replace(/\bbac\s*si\b/g, " ")
    .replace(/\bb\s*s\b/g, " ")
    .replace(/\bbs\b/g, " ")
    .replace(/\bbsi\b/g, " ")
    .replace(/\bdr\b/g, " ")
    .replace(/\bdoctor\b/g, " ")
    .replace(/\bmd\b/g, " ")
    .replace(/\s+/g, " ")
    .trim();

  // "bác sĩ"/"bs"/"dr"... => trả toàn bộ bác sĩ
  if (doctorWord && !qRest) return doctors;

  const needle = qRest || qNorm;
  const tokens = needle.split(" ").filter(Boolean);

  return doctors.filter((doctor) => {
    const haystack = normalizeVi(
      [
        doctor?.name,
        doctor?.specialty,
        doctor?.title,
        doctor?.titleDescription,
        doctor?.position,
      ]
        .filter(Boolean)
        .join(" ")
    );

    return tokens.every((t) => haystack.includes(t));
  });
}

export function searchClinics(query: string, clinics: ClinicScheduleStatusDto[]): ClinicScheduleStatusDto[] {
  const qRaw = (query ?? "").trim();
  if (!qRaw) return clinics;

  const qNorm = normalizeVi(qRaw);

  // Phát hiện alias/phrasings của "phòng khám"
  const clinicWord = /\bphong\s*kham\b|\bpk\b|\bp\s*k\b|\bclinic\b|\bpolyclinic\b/.test(qNorm);

  // Loại bỏ các alias "phòng khám" để lấy phần keyword còn lại
  const qRest = qNorm
    .replace(/\bphong\s*kham\b/g, " ")
    .replace(/\bp\s*k\b/g, " ")
    .replace(/\bpk\b/g, " ")
    .replace(/\bclinic\b/g, " ")
    .replace(/\bpolyclinic\b/g, " ")
    .replace(/\s+/g, " ")
    .trim();

  // (pk/phòng khám/clinic) -> trả toàn bộ
  if (clinicWord && !qRest) return clinics;

  const needle = qRest || qNorm;
  const tokens = needle.split(" ").filter(Boolean);

  return clinics.filter((clinic) => {
    const haystack = normalizeVi(
      [
        clinic?.clinicName,
        clinic?.description,
        (clinic as any)?.departmentName,
        (clinic as any)?.roomName,
        String((clinic as any)?.roomCode ?? "")
      ]
        .filter(Boolean)
        .join(" ")
    );

    return tokens.every((t) => haystack.includes(t));
  });
}
